import { Action } from '@ngrx/store';
import { ContactPerson } from '@ordersnproducts/modules/order-builder/modules/location-specification/models/order-management/contact-person.model';

export enum ActionTypes {
  FETCH_CONTACTS = '[Bulk CEM UL Modify] Fetch Contacts',
  STORE_CONTACTS = '[Bulk CEM UL Modify] Store Contacts',
  ADD_NEW_CONTACT = '[Bulk CEM UL Modify] Add New Contact',
  CLEAR_CONTACTS = '[Bulk CEM UL Modify] Clear Contacts',
  SELECT_CONTACT = '[Bulk CEM UL Modify] Select Contact',
}

export class FetchContacts implements Action {
  readonly type: string = ActionTypes.FETCH_CONTACTS;
  constructor(public payload?: any) {}
}

export class StoreContacts implements Action {
  readonly type: string = ActionTypes.STORE_CONTACTS;
  constructor(public payload: ContactPerson[]) {}
}

export class AddNewContact implements Action {
  readonly type: string = ActionTypes.ADD_NEW_CONTACT;
  constructor(public payload: ContactPerson) {}
}

export class ClearContacts implements Action {
  readonly type: string = ActionTypes.CLEAR_CONTACTS;
  constructor(public payload?: any) {}
}

export class SelectContact implements Action {
  readonly type: string = ActionTypes.SELECT_CONTACT;
  constructor(public payload: number, public manualChange?: boolean) {}
}

export type Actions = FetchContacts | StoreContacts | AddNewContact | ClearContacts | SelectContact;
